class SOSAnalysisDelegate {
    setSelectedTag(selectedTag) {
        this.setState({ selectedTag });
    }

    setSelectedStore(selectedStore) {
        this.setState({ selectedStore });
    }

    setStoresData(storesData) {
        this.setState({ storesData });
    }

    setAnalysisLoading(analysisLoading) {
        this.setState({ analysisLoading });
    }
}

export default SOSAnalysisDelegate;
